import { useState } from "react";
import { Button } from "@/components/ui/button";
import { LoadingButton } from "@/components/LoadingButton";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDelete: () => Promise<void>;
  children: React.ReactNode;
}

export function DeleteUserDialog({
  open,
  onOpenChange,
  onDelete,
  children,
}: DeleteUserDialogProps) {
  const [loading, setLoading] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {children}
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete User</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this user? This action cannot be
            undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <LoadingButton
            variant="destructive"
            loading={loading}
            onClick={async () => {
              setLoading(true);
              try {
                await onDelete();
                onOpenChange(false);
              } finally {
                setLoading(false);
              }
            }}
          >
            Delete User
          </LoadingButton>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
